import { common } from '@ocean/ui'
import {
  InfoListLayout,
  InfoListSeparator,
  InfoListRow,
  InfoListLabel,
  InfoListValue,
} from 'layouts/infoLists'
import { InfoListSkeletonWrapper } from '../Skeleton.styled'

const { ContentTrace, Translucent } = common.skeletonStyles

const InfoListSkeleton: React.FC = () => (
  <Translucent opacity='0.7' data-test='InfoListSkeleton'>
    <InfoListSkeletonWrapper>
      <InfoListLayout labelWidth='230px'>
        <InfoListRow>
          <InfoListLabel>
            <ContentTrace width='70%' color='greyLight' />
          </InfoListLabel>
          <InfoListValue>
            <ContentTrace width='30%' color='greyLight' />
          </InfoListValue>
        </InfoListRow>
        <InfoListSeparator />
        <InfoListRow>
          <InfoListLabel>
            <ContentTrace width='90%' color='greyLight' />
          </InfoListLabel>
          <InfoListValue>
            <ContentTrace width='25%' color='greyLight' />
          </InfoListValue>
        </InfoListRow>
        <InfoListSeparator />
        <InfoListRow>
          <InfoListLabel>
            <ContentTrace width='60%' color='greyLight' />
          </InfoListLabel>
          <InfoListValue>
            <ContentTrace width='40%' color='greyLight' />
          </InfoListValue>
        </InfoListRow>
      </InfoListLayout>
    </InfoListSkeletonWrapper>
  </Translucent>
)

export default InfoListSkeleton
